import { render, staticRenderFns } from "./goHome.vue?vue&type=template&id=6202c6ca&scoped=true"
import script from "./goHome.vue?vue&type=script&lang=js"
export * from "./goHome.vue?vue&type=script&lang=js"
import style0 from "./goHome.vue?vue&type=style&index=0&id=6202c6ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6202c6ca",
  null
  
)

export default component.exports